import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { showModel, hideModel, updatePassword, resetServerErrorMessage } from '../Actions/ResetPassword.action';

const ResetPassword = () => {
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    showNewPasswordValidation: false,
    showPasswordNotMatch: false,
  });

  const dispatch = useDispatch(),
    showPop = useSelector((state) => state.resetPasswordPopup.showPop),
    errors = useSelector((state) => state.resetPasswordPopup.errors);

  const getStatus = () => (showPop == null ? false : showPop);

  const updateState = (field, value) => {
    setPasswordData((prevState) => {
      const updatedState = { ...prevState, [field]: value };

      if (errors && errors != {}) {
        dispatch(resetServerErrorMessage());
      }

      if (field === 'newPassword') {
        updatedState.showNewPasswordValidation = false;
        updatedState.showPasswordNotMatch = prevState.confirmPassword !== '' && prevState.confirmPassword !== value;
      }

      if (field === 'confirmPassword') {
        updatedState.showPasswordNotMatch = prevState.newPassword !== value;
      }

      return updatedState;
    });
  };

  const savePassword = () => {
    if (!passwordData.showPasswordNotMatch && !passwordData.showNewPasswordValidation) {
      if (passwordData.oldPassword !== '' || passwordData.newPassword !== '') {
        dispatch(updatePassword(passwordData.oldPassword, passwordData.newPassword, passwordData.confirmPassword));
      }
    }
  };

  return (
    <>
      {!getStatus() && (
        <a
          className='button  submit small'
          onClick={() => dispatch(showModel())}
        >
          <span>{translate('resetpassword.name')}</span>
        </a>
      )}

      {getStatus() && (
        <div className='modal'>
          <div className='modal__bg--overlay'></div>
          <div className='modal__inner reset-password'>
            <a className='modal__close' onClick={() => dispatch(hideModel())}>
              <svg>
                <use href='/ui/images/sprites/be-group.svg#close'></use>
              </svg>
            </a>
            <h2>{translate('resetpassword.resetpasswordtitle')}</h2>

            <div className='reset-password__errors'>
              {passwordData.showNewPasswordValidation && (
                <p>{translate('resetpassword.showregexvalidationmessage')}</p>
              )}
              {passwordData.showPasswordNotMatch && (
                <p>{translate('resetpassword.showpassworddoesnotmatch')}</p>
              )}
              {errors && errors['general'] && (
                <span className='error-allfields'>{errors['general'][0]}</span>
              )}
              {errors && errors['passwordForm.Password'] && (
                <span className='error-allfields'>
                  {errors['passwordForm.Password'][0]}
                </span>
              )}
            </div>

            <div className='modal__name-shoping'>
              <p>{translate('resetpassword.oldpassword')}</p>
              <input
                type='text'
                onChange={(event) =>
                  updateState('oldPassword', event.target.value)
                }
              ></input>
            </div>
            <div className='modal__name-shoping'>
              <p>{translate('resetpassword.newpassword')}</p>
              <input
                type='text'
                onChange={(event) =>
                  updateState('newPassword', event.target.value)
                }
              ></input>
            </div>
            <div className='modal__name-shoping'>
              <p>{translate('resetpassword.confirmpassword')}</p>
              <input
                type='text'
                onChange={(event) =>
                  updateState('confirmPassword', event.target.value)
                }
              ></input>
            </div>
            <div className='modal__actions reset-password__actions'>
              <a className='button button--orange' onClick={savePassword}>
                {translate('resetpassword.changepassword')}
              </a>
              <a
                className='button button--transparent'
                onClick={() => dispatch(hideModel())}
              >
                {translate('resetpassword.closepopup')}
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPassword;
